import {Injectable} from '@angular/core';
import {AppLinksService} from '../app-links.service';
import {MealType} from '../DataModels/Meal';
import {Router} from '@angular/router';
import {ModalController, PopoverController} from "@ionic/angular";
import {closeAllModals, closeAllPopovers} from "../helpers/helpers";

@Injectable({
  providedIn: 'root'
})
export class LaunchTrackerService {

  private mealType: MealType | undefined;

  constructor(private appLinksService: AppLinksService, private router: Router, private modalController: ModalController,
              private popoverController: PopoverController) {
    this.getAppLink(true);
    this.appLinksService.newLinkSubject.subscribe(() => this.getAppLink());
  }

  public trackMeal(): MealType | undefined {
    if (this.mealType === undefined) { return; }
    const mealType = this.mealType;
    this.mealType = undefined;
    return mealType;
  }

  private getAppLink(firstTime = false): void {
    const result = this.appLinksService.getLinkThatContains('/track-meal');
    if (!result) { return; }
    const split = result.split('track-meal/');
    if (!split || !split[1]) { return; }
    let mealType: MealType;
    switch (split[1]) {
      case 'breakfast':
        mealType = MealType.Breakfast;
        break;
      case 'lunch':
        mealType = MealType.Lunch;
        break;
      case 'dinner':
        mealType = MealType.Dinner;
        break;
      case 'snack':
        mealType = MealType.Snack;
        break;
      default:
        return;
    }
    this.mealType = mealType;
    closeAllModals(this.modalController);
    closeAllPopovers(this.popoverController);
    this.router.navigateByUrl('/food-tracker/tracker').then();
    if (firstTime) { this.getAppLink(true); }
  }
}
